import Additional from "./Additional";
import Details from "./Details";
import LoginSessions from "./LoginSessions";
import StaffDetails from "./StaffDetails";
import TypeOfMember from "./TypeOfMember";
import { UserDetails } from "./UserDetails";

export const Steps = {
  TYPE_OF_MEMBER: TypeOfMember,
  DETAILS: Details,
  USER_DETAILS: UserDetails,
  STAFF_DETAILS: StaffDetails,
  ADDITIONAL: Additional,
  LOGIN_SESSIONS: LoginSessions,
};
